export default __webpack_public_path__ + "static/media/winner-bg.f948b4ec.png";